import React from 'react';
import styled from 'styled-components';
import { Dropdown } from 'semantic-ui-react';

const Wrapper = styled.div`
transform: translateX(-50%);
top: 30px;
position: relative;
width: 60%;
left: 50%;
z-index: 2;

&:focus {outline:0;}

&>div>i{
  color: white;
  top: 30px;
}
&>div >div{
  color: white !important;
  font-size: 13px;
  font-family: 'Roboto' !important;
  font-weight: 400 !important;
${'' /* letter-spacing: 1.5px; */}
${'' /* line-height: 1.2 !important; */}
}
&>.ui{
  background: #ffffff00 !important;
  border-bottom: 1px solid white !important;
  -webkit-appearance: none;
}
`

export default class DropdownSelect extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      titleList: null,
    }
    this.currentSelectedItem = props.currentSelectedItem;
    this.changeSelectedItem = props.changeSelectedItem;
    this.generateDropdown = this.generateDropdown.bind(this);
  }

  componentWillReceiveProps(nextProps){
    this.list = nextProps.list;
    this.setState({titleList: this.list.map(d => {
      if (d.dropDownQuestion != null) {
        return d.dropDownQuestion
      } else {
        return d.description
      }
    })
  })
}


generateDropdown(){

  const output = [];
  const strLimit = 180;
  if(this.state.titleList && this.state.titleList.length>0){
    this.state.titleList.forEach((d,i)=>{

      output[i] = {
        key: i,
        value: i,
        text: d.length> strLimit ? d.substring(0,strLimit) + '...' : d
      }
    })
    return output;
  }else{
    return []
  }

}
render(){
  return(
    <Wrapper>
      <Dropdown fluid defaultValue={this.currentSelectedItem} selection options={this.generateDropdown()} onChange={(e,d) => this.changeSelectedItem(d.value)} />
  </Wrapper>
)
}
}



// WEBPACK FOOTER //
// ./src/App/components/DropdownSelect.js